import type { ReactNode } from 'react';

/**
 * The failed-read state of a billing panel (billing history, saved cards).
 *
 * Exists because both panels used to fall through to their EMPTY copy when
 * the request failed — "No invoices yet", "No payment methods on file yet" —
 * which is a false statement about someone's money, and in the card list's
 * case an invitation to add a duplicate card. `role='alert'` so the failure is
 * announced rather than only drawn.
 */
export function BillingReadError({ children }: { children: ReactNode }) {
  return (
    <p
      role='alert'
      className='rounded-lg border border-destructive/30 bg-destructive/10 p-4 text-sm text-destructive-emphasis'
    >
      {children}
    </p>
  );
}
